import AppCard from 'emerald-ui/lib/AppCard';
import educationSvg from './assets/education.svg';
import credentialingSvg from './assets/credentialing.svg';
import hrSvg from './assets/human-resources.svg';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: AppCard, componentName: 'AppCard' }], 'AppCard'),
  description: 'An AppCard is an animated card-like link that appears in the Launchpad of different products.',
  codeSamples: [
    {
      title: 'Default',
      scope: { AppCard, educationSvg, credentialingSvg, hrSvg },
      code: `// The following icons are real files that need to be imported

<div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap' }}>
  <AppCard
    color="#fdd760"
    caption="Education"
    image={educationSvg}
    style={{ marginBottom: '20px' }}
  />
  <AppCard
    color="#f0e7ff"
    caption="Credentialing"
    image={credentialingSvg}
    style={{ marginBottom: '20px' }}
  />
  <AppCard
    color="#dce9ff"
    caption="Human resources"
    image={hrSvg}
    style={{ marginBottom: '20px' }}
  />
</div>`,
    },
  ],
};
